import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import cn from 'classnames';
import { useHelloWorld, useUpdateHelloWorld } from '../../api/hooks';
import style from './style';
import { User } from 'connex-cds';
import { PERMISSIONS } from '../../permissions';

const Styled = styled.div`
  ${style}
`;

export const Landing = () => {
  const { entityRef } = useParams();
  const { Has } = User.useHasPermission();

  const query = useHelloWorld();

  const updateQuery = useUpdateHelloWorld();

  const handleClick = React.useCallback(async () => {
    const response = await updateQuery({ entityRef, data: { test: 'ABCD-1234' } });
    console.log('response', response);
  }, [entityRef, updateQuery]);

  return (
    <Styled className={cn('landing')}>
      Landing:
      {query?.data?.message}
      <div>
        <button onClick={handleClick}>Click Me</button>
      </div>
      {/*  Permissions demo - see menu-config.js for additional usages */}
      <Has permission={PERMISSIONS.PERM_1}>
        <div>Has Perm1</div>
      </Has>
      <Has not permission={PERMISSIONS.PERM_2}>
        <div>Does not have Perm2</div>
      </Has>
    </Styled>
  );
};
